const GET_CHROME_VERSION_REGEX = /Chrome\/(\d+)/;

export const getChromeVersion = (): number | null => {
    const matchedRegex = navigator.userAgent.match(GET_CHROME_VERSION_REGEX);

    if (!matchedRegex) return null;

    const chromeVersion = Number(matchedRegex[1]);

    return !Number.isNaN(chromeVersion) ? chromeVersion : null;
};
